<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group bmd-form-group">
        <label>{{ observation.user.name }}({{ observation.user.username }}) {{ observation.created_at | moment('DD/MM/YYYY HH:mm:ss') }} - {{ observation.text }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    observation: {
      type: [Object],
      default() {
        return {};
      }
    }
  }
};
</script>

<style scoped>
</style>